<template>
	<div class="">
		<b-form @submit.prevent="saveRatePlan">
			<b-overlay :show="loading" no-wrap></b-overlay>
			<b-form-row class="flex justify-content-center">
				<b-col lg="10">
					<div>
						<slot name="header-form"></slot>
					</div>
					<b-form-row>
						<b-form-group :label="$t('global.name')" class="col-lg-5 col-12">
							<b-form-input v-model="formModel.name" required></b-form-input>
						</b-form-group>
						<b-form-group :label="$t('ratePlan.operationArea')" class="col-lg-6 col-12">
							<template #label>{{ $t('ratePlan.operationArea') }}
								<button type="button" class="btn btn-link p-0 pl-1" v-if="formModel.zonedAreaId>0" @click="fnShowZonedArea"><small>{{$t("ratePlan.showZonedAreaSelected")}}</small></button>
							</template>
							<b-form-select :options="optsZonedAreas" v-model="formModel.zonedAreaId" required></b-form-select>
						</b-form-group>
					</b-form-row>
					<b-form-row >
						<b-form-group :label="$t('ratePlan.currency')" class="col-lg-3 col-12">
							<b-form-select :options="optsCurrencies" v-model="formModel.currency" required ></b-form-select>
						</b-form-group>
						<b-form-group :label="$t('ratePlan.startDate')" class="col-lg-4 col-12">
							<b-form-datepicker :locale="$root.store.state.currentUser.lang" :class="{'active-filter':formModel.startDate}" reset-button v-model="formModel.startDate"/>
						</b-form-group>
						<b-form-group :label="$t('ratePlan.endDate')" class="col-lg-4 col-12">
							<b-form-datepicker :locale="$root.store.state.currentUser.lang" :class="{'active-filter':formModel.endDate}" reset-button  v-model="formModel.endDate"/>
						</b-form-group>
					</b-form-row>
					<b-form-row>
						<b-form-group :label="$t('global.description')" class="col-lg-12 col-12">
							<b-textarea
								type="text"
								v-model="formModel.description"
							/>
						</b-form-group>
					</b-form-row>
					<b-form-row class="text-right mt-3 mr-1">
						<b-col>
							<b-button type="button" variant="secondary mr-2" size="lg" @click="$emit('close')">{{ $t("global.cancel") }}</b-button>
							<b-button type="submit" variant="primary" size="lg">{{ $t("global.save") }}</b-button>
						</b-col>
					</b-form-row>

				</b-col>
			</b-form-row>

		</b-form>
		<b-modal v-model="showZonedArea" v-if="showZonedArea" size="xl" >
			<h3>{{ $t("ratePlan.operationArea") }} : <b>{{ zonedAreaDataSelected.name }}</b></h3>
			<MapZones  :zoned-area="zonedAreaDataSelected" mode="readonly"></MapZones>
		</b-modal>
	</div>
</template>

<script>
import MapZones from './../../zoned-areas/MapZones.vue'
export default {
	props: {
		ratePlanFor:{
			type:Object,
			required:true,
			default:()=>{
				return {for:"salesChannel",id:""}
			}
		}
	},
	data() {
		return {
			modelId: -1,
			formModel:{
				salesChannelId:null,
				name:"",
				currency:null,
				zonedAreaId:null,
				description:"",
				startDate:"",
				endDate:""
			},
			showZonedArea:false,
			zonedAreaDataSelected:null,
			loading:false
		};
	},
	components: { MapZones},
	computed:{
		optsCurrencies() {
			return [...[{value:null,text:this.$t("global.selectOption"),disabled:true}],...this.$root.auxVars.currencyOpts];
		},
		optsZonedAreas() {
			return [...[{value:null,text:this.$t("global.selectOption"),disabled:true}],...this.$root.auxVars.zonedAreasOpts];
		}
	},
	methods: {
		fetchModel(){
			if (this.modelId > 0) {
				this.loading = true;
				this.$root.api
					.get(`/rate-plans/${this.modelId}`)
					.then(res => {
						this.formModel = { ...res.data };
						this.loading = false;
					})
					.catch((err)=>{
						this.$root.handleRequestError(err)
						this.$refs["modal-view"].hide();

					});
			}
		},
		loadModel(id){
			this.modelId = id;
			setTimeout(() => {
				this.fetchModel();
			}, 0);
		},
		fetchZonedAreaData(){
			if(!this.formModel.zonedAreaId) return;
			return this.$root.api.get(`/zoned-areas/${this.formModel.zonedAreaId}`).then( res => {
				return res.data;
			}).catch(this.$root.handleRequestError);
		},
		fetchSalesChannelData(){
			if(!this.formModel.zonedAreaId) return;
			return this.$root.api.get(`/resource/zoned-areas/${this.formModel.zonedAreaId}`).then( res => {
				return res.data;
			}).catch(this.$root.handleRequestError);
		},
		async fnShowZonedArea(){
			this.zonedAreaDataSelected  = await this.fetchZonedAreaData();
			setTimeout(()=>{
				this.showZonedArea =true;
			},0)
		},
		saveRatePlan(){
			this.loading = true;
			let rParams = {
				url:
					this.modelId > 0
						? `/rate-plans/${this.modelId}`
						: "/rate-plans",
				method: this.modelId > 0 ? "put" : "post"
			};
			let data = {...this.ratePlanFor,...this.formModel};
			rParams["data"] = data;
			this.$root.api
				.request(rParams)
				.then(res => {
					this.$root.showAlert(
						rParams.method == "post"
							? this.$t("global.registeredSuccess")
							: this.$t("global.doneSuccessfully")
					);
					console.log(res)
					if (res.data.id) this.loadModel(res.data.id);
					setTimeout(() => {
						this.$emit("submitted");
					}, 0);
				})
				.catch(this.$root.handleRequestError)
				.then(() => {
					this.loading = false;
				});

		}
	},
	mounted() {
		this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['zonedAreasOpts']})
		if(this.ratePlanFor.for=="salesChannel"){
			this.formModel.salesChannelId = this.ratePlanFor.id;
		}
		console.log("mounted single ");
	}
};
</script>

<style scoped>
.mt-4 {
	margin-top: 1.5rem;
}
.mt-3 {
	margin-top: 1rem;
}
</style>
